import type { ReactNode } from 'react'

/** Page chrome for content screens. A calm header band on the canvas —
 *  title in ink (the brand lives "at the door" in the sidebar, content stays
 *  calm), optional subtitle + right-aligned actions — then a max-width body.
 *
 *  Replaces the old marketing `.section-header` cream strip. */
export function Page({
  title,
  subtitle,
  actions,
  breadcrumb,
  children,
  bodyClass = 'mx-auto max-w-screen-2xl px-8 py-8',
}: {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
  breadcrumb?: ReactNode
  children: ReactNode
  bodyClass?: string
}) {
  return (
    <>
      <header className="border-b border-line bg-surface">
        <div className="mx-auto flex max-w-screen-2xl items-start justify-between gap-6 px-8 py-5">
          <div className="min-w-0">
            {breadcrumb ? <div className="mb-1.5">{breadcrumb}</div> : null}
            <h1 className="truncate text-2xl font-bold tracking-tight text-ink">{title}</h1>
            {subtitle ? <p className="mt-1 text-sm text-ink-soft">{subtitle}</p> : null}
          </div>
          {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
      </header>
      <div className={bodyClass}>{children}</div>
    </>
  )
}
